/* eslint-disable indent */
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
// import { createStore, applyMiddleware, compose } from 'redux';
// import thunk from 'redux-thunk';
// // import { logger } from 'redux-logger';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {
  setAuthorizationToken,
  setAxiosTimezone,
} from "./libs/set_auth_token.utils";
import store from "./store";
import { AUTH_USER } from "./actions/Auth.action";
import {
  actionChangeTheme,
  actionGetAppSettings,
  actionGetClientTheme,
} from "./actions/AppSettings.action";
import { GoogleOAuthProvider } from '@react-oauth/google';
import constants from './config/constants';
import { getClientDomain } from "./libs/domain.utils";

setAxiosTimezone();
if (localStorage.theme) {
  store.dispatch(actionChangeTheme(localStorage.theme));
} else {
  store.dispatch(actionChangeTheme("light"));
}
// Fetch client theme by domain (runs both when logged in and when on login page)
const domain = getClientDomain();
if (domain) {
  store.dispatch(actionGetClientTheme(domain));
}

// Subscribe to client theme changes to update favicon and other elements
store.subscribe(() => {
  const state = store.getState();
  const clientTheme = state.app_setting?.client_theme;
  if (clientTheme?.fav_icon) {
    let link = document.querySelector("link[rel='shortcut icon']") || document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "shortcut icon";
      document.head.appendChild(link);
    }
    link.href = clientTheme.fav_icon;
  }
});

// Poll for theme updates every 30 seconds to pick up changes from admin panel
const themePollInterval = setInterval(() => {
  if (domain) {
    store.dispatch(actionGetClientTheme(domain));
  }
}, 30000);

// Cleanup interval on unmount (store is global, but we track for cleanup)
if (window.cleanupFunctions) {
  window.cleanupFunctions.push(() => clearInterval(themePollInterval));
} else {
  window.cleanupFunctions = [() => clearInterval(themePollInterval)];
}

if (localStorage.jwt_token) {
  setAuthorizationToken(localStorage.jwt_token);
  store.dispatch({
    type: AUTH_USER,
    payload: {
      ...JSON.parse(localStorage.user),
      token: localStorage.jwt_token,
    },
  });
  // store.dispatch(actionGetDashboard());
  store.dispatch(actionGetAppSettings());
  // connectToSocket(localStorage.jwt_token);
} else {
  // connectToSocket();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={constants.GOOGLE_AUTH_KEY}>
  {/* // <React.StrictMode> */}
  <Provider store={store}>
    <App />
  </Provider>
  {/* // </React.StrictMode> */}
  </GoogleOAuthProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
